package com.dotdrives.model

/** Only genuine manual entry fields; source, steward and identity are server-owned. */
fun NewDonation.manualGiftFields(): Map<String, String> = buildMap {
    put("giver_id", giverId)
    put("amount", amount.toString())
    put("payment_type", paymentType)
    put("memo", memo)
    put("occurred_at", occurredAt.toString())
    driveId?.let { put("drive_id", it) }
    pledgeId?.let { put("pledge_id", it) }
    targetId?.let { put("target_id", it) }
}
